import type { UIViewInjectedProps } from '@uirouter/react';

import { Attachments } from '@/components/attachments';
import { AttachmentType } from '@/types/enums';

export const CooperativePolygonAttachments = ({ transition }: UIViewInjectedProps) => {
  const params = {
    transition,
    apiEntity: 'CooperativePolygon',
    paramId: 'cooperativeId',
    attachmentType: AttachmentType.CooperativePolygon,
    closeRoute: 'base-layout.cooperatives.view',
    isDrawerLayout: false,
  };

  return <Attachments<cyrian.api.cooperatives.CooperativeWithAttachment> {...params} />;
};
